import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  tuningFork: {
    id: UpgradeType.TuningFork,
    icon: ['fork', 'plus1'],
    cost: { gold: 1200 },
    costGrowthRate: 1.5,
    multiplier: 0, // Base is already in generator (0.01)
    purchased: 0,
    bonusPerOwned: 0.005, // Adds 0.001 per tick per level purchased
    purchaseLimit: 60,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  luteSolo: {
    id: UpgradeType.LuteSolo,
    icon: ['lute1', 'arrowUp1'],
    cost: { gold: 20000 },
    costGrowthRate: 2.5,
    multiplier: 1.5, // Initial max multiplier
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 7,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  piercedEardrums: {
    id: UpgradeType.PiercedEardrums,
    icon: ['ear', 'h_bang5'],
    cost: { gold: 15000 },
    costGrowthRate: 1.8,
    multiplier: 100,
    purchased: 0,
    bonusPerOwned: -5,
    purchaseLimit: 10,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  obnoxiousGuitarist: {
    id: UpgradeType.ObnoxiousGuitarist,
    icon: ['devilHorns', 'clockUp'],
    // Expensive upgrade that extends the active duration of Inspiration
    cost: { gold: 2500 },
    costGrowthRate: 2,
    multiplier: 10, // Initial active duration in seconds/ticks
    purchased: 0,
    bonusPerOwned: 1, // Increases duration by 1 per purchase
    purchaseLimit: 50,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  encore: {
    id: UpgradeType.Encore,
    icon: ['flute1', 'clockDown'],
    // Starts with a long cooldown that shrinks quickly as you buy levels
    cost: { gold: 700 },
    costGrowthRate: 1.85,
    multiplier: 60, // Initial cooldown duration in seconds/ticks
    purchased: 0,
    bonusPerOwned: -1, // Reduces cooldown by 1 per purchase
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  lockerRoomSpeech: {
    id: UpgradeType.LockerRoomSpeech,
    icon: ['offline'],
    cost: { gold: 50000 },
    costGrowthRate: 1.5,
    multiplier: 0, // Base is 0% (no offline generation)
    purchased: 0,
    bonusPerOwned: 10, // Adds 10% per level (0%, 10%, 20%, 30%, 40%, 50%... 100%)
    purchaseLimit: 10,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
};
